import { BehaviorSubject } from "rxjs";
import { v4 as uuid } from "uuid";
import { DMVDataService } from "./dmv-data.service";
import * as i0 from "@angular/core";
import * as i1 from "./dmv-data.service";
export class DMVStoreService {
    constructor(dmvDataService) {
        this.dmvDataService = dmvDataService;
        this.firstRegistration = null;
        this.addressrequired = false;
        this.isPrivacyCheck = false;
        /** ---------Start - Observable data service to get registrations -------------*/
        this._registrations = new BehaviorSubject(null);
        this.registrations$ = this._registrations.asObservable();
        //Data access by consumers
        this.registrationData$ = this
            .registrations$;
        this.selectedAgencyId = "";
        this.addToProfileState = undefined;
        this.states = [
            { name: "Alabama", alpha: "AL" },
            { name: "Alaska", alpha: "AK" },
            { name: "Arizona", alpha: "AZ" },
            { name: "Arkansas", alpha: "AR" },
            { name: "California", alpha: "CA" },
            { name: "Colorado", alpha: "CO" },
            { name: "Connecticut", alpha: "CT" },
            { name: "Delaware", alpha: "DE" },
            { name: "District of Columbia", alpha: "DC" },
            { name: "Florida", alpha: "FL" },
            { name: "Georgia", alpha: "GA" },
            { name: "Hawaii", alpha: "HI" },
            { name: "Idaho", alpha: "ID" },
            { name: "Illinois", alpha: "IL" },
            { name: "Indiana", alpha: "IN" },
            { name: "Iowa", alpha: "IA" },
            { name: "Kansa", alpha: "KS" },
            { name: "Kentucky", alpha: "KY" },
            { name: "Lousiana", alpha: "LA" },
            { name: "Maine", alpha: "ME" },
            { name: "Maryland", alpha: "MD" },
            { name: "Massachusetts", alpha: "MA" },
            { name: "Michigan", alpha: "MI" },
            { name: "Minnesota", alpha: "MN" },
            { name: "Mississippi", alpha: "MS" },
            { name: "Missouri", alpha: "MO" },
            { name: "Montana", alpha: "MT" },
            { name: "Nebraska", alpha: "NE" },
            { name: "Nevada", alpha: "NV" },
            { name: "New Hampshire", alpha: "NH" },
            { name: "New Jersey", alpha: "NJ" },
            { name: "New Mexico", alpha: "NM" },
            { name: "New York", alpha: "NY" },
            { name: "North Carolina", alpha: "NC" },
            { name: "North Dakota", alpha: "ND" },
            { name: "Ohio", alpha: "OH" },
            { name: "Oklahoma", alpha: "OK" },
            { name: "Oregon", alpha: "OR" },
            { name: "Pennsylvania", alpha: "PA" },
            { name: "Rhode Island", alpha: "RI" },
            { name: "South Carolina", alpha: "SC" },
            { name: "South Dakota", alpha: "SD" },
            { name: "Tennessee", alpha: "TN" },
            { name: "Texas", alpha: "TX" },
            { name: "Utah", alpha: "UT" },
            { name: "Vermont", alpha: "VT" },
            { name: "Virginia", alpha: "VA" },
            { name: "Washington", alpha: "WA" },
            { name: "West Virginia", alpha: "WV" },
            { name: "Wisconsin", alpha: "WI" },
            { name: "Wyoming", alpha: "WY" }
        ];
        /** ---------------------------------------------------------------------------  */
        /** ---------Start - Observable data service to get agency config ---------------*/
        this._agencyConfig = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.agencyConfig$ = this._agencyConfig.asObservable();
        //Data access by consumers
        this.agencyConfigData$ = this.agencyConfig$;
        this._cancellationToken = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.cancellationToken$ = this._cancellationToken.asObservable();
        //Data access by consumers
        this.cancellationTokengData$ = this.cancellationToken$;
        /** ---------Start - Observable data service to get agency config ---------------*/
        this._tagCatalog = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.tagCatalog$ = this._tagCatalog.asObservable();
        //Data access by consumers
        this.tagCatalogData$ = this.tagCatalog$;
        /** ---------------------------------------------------------------------------  */
        this._donationOrgs = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.donationOrgs$ = this._donationOrgs.asObservable();
        //Data access by consumers
        this.donationOrgsData$ = this.donationOrgs$;
        /** ---------------------------------------------------------------------------  */
        this._registrationTypes = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.registrationTypes$ = this._registrationTypes.asObservable();
        //Data access by consumers
        this.registrationTypesData$ = this.registrationTypes$;
        /** ---------------------------------------------------------------------------  */
        this._dmvCost = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.dmvCost$ = this._dmvCost.asObservable();
        //Data access by consumers
        this.dmvCostData$ = this.dmvCost$;
        /** ---------------------------------------------------------------------------  */
        this._renewal = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.renewal$ = this._renewal.asObservable();
        //Data access by consumers
        this.renewalData$ = this.renewal$;
        /** ---------------------------------------------------------------------------  */
        this._serviceFeeAmount = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.serviceFeeAmount$ = this._serviceFeeAmount.asObservable();
        //Data access by consumers
        this.serviceFeeAmountData$ = this.serviceFeeAmount$;
        /** ---------------------------------------------------------------------------  */
        this._renewalSubmit = new BehaviorSubject(null);
        // Expose the observable$ part (read only stream)
        this.renewalSubmit$ = this._renewalSubmit.asObservable();
        //Payment URL
        //public paymentURL = "https://qavsuite.pnpit.com/vembed/payment-frame?agencyid=%27cssexample%27&accesstoken=%27abc-123%27&firstName=%27Test%27&lastName=%27User%27";
        this.isPaymentSuccess = false;
        //Data access by consumers
        this.renewalSubmitData$ = this.renewalSubmit$;
    }
    // The getter will return the last value emitted
    get registrations() {
        return this._registrations.getValue();
    }
    // Assigning a value will push it onto the observable
    set registrations(val) {
        this._registrations.next(val);
    }
    //Funding token
    //private fundingTokenFromProvider: string = "";
    get fundingToken() {
        return uuid();
    }
    // The getter will return the last value emitted
    get agencyConfig() {
        return this._agencyConfig.getValue();
    }
    // Assigning a value will push it onto the observable
    set agencyConfig(val) {
        this._agencyConfig.next(val);
    }
    // The getter will return the last value emitted
    get cancellationTokenData() {
        return this._cancellationToken.getValue();
    }
    // Assigning a value will push it onto the observable
    set cancellationTokenData(val) {
        this._cancellationToken.next(val);
    }
    // The getter will return the last value emitted
    get tagCatalog() {
        return this._tagCatalog.getValue();
    }
    // Assigning a value will push it onto the observable
    set tagCatalog(val) {
        this._tagCatalog.next(val);
    }
    // The getter will return the last value emitted
    get donationOrgs() {
        return this._donationOrgs.getValue();
    }
    // Assigning a value will push it onto the observable
    set donationOrgs(val) {
        this._donationOrgs.next(val);
    }
    // The getter will return the last value emitted
    get registrationTypes() {
        return this._registrationTypes.getValue();
    }
    // Assigning a value will push it onto the observable
    set registrationTypes(val) {
        this._registrationTypes.next(val);
    }
    // The getter will return the last value emitted
    get dmvCost() {
        return this._dmvCost.getValue();
    }
    // Assigning a value will push it onto the observable
    set dmvCost(val) {
        this._dmvCost.next(val);
    }
    // The getter will return the last value emitted
    get renewal() {
        return this._renewal.getValue();
    }
    // Assigning a value will push it onto the observable
    set renewal(val) {
        this._renewal.next(val);
    }
    // The getter will return the last value emitted
    get serviceFeeAmount() {
        return this._serviceFeeAmount.getValue();
    }
    // Assigning a value will push it onto the observable
    set serviceFeeAmount(val) {
        this._serviceFeeAmount.next(val);
    }
    // The getter will return the last value emitted
    get renewalSubmit() {
        return this._renewalSubmit.getValue();
    }
    // Assigning a value will push it onto the observable
    set renewalSubmit(val) {
        this._renewalSubmit.next(val);
    }
    /** ---------------------------------------------------------------------------  */
    findTagCatalog() {
        this.dmvDataService.getTagCatalogResponse(this.sessionID).subscribe(response => {
            if (response) {
                this.tagCatalog = response;
            }
        }, error => {
            error.status = 408;
            this.tagCatalog = error;
        });
    }
    findDonationOrgs() {
        this.dmvDataService.getDonationOrgsResponse(this.sessionID).subscribe(response => {
            if (response) {
                this.donationOrgs = response;
            }
        }, error => {
            error.status = 408;
            this.donationOrgs = error;
        });
    }
    updateAddress() {
        this.registrationsInCart.addressComefrom = undefined;
        if (this.registrationsInCart.selectedRegistrations) {
            this.firstRegistration = this.registrationsInCart.selectedRegistrations[0];
        }
        this.mailingAddress = Object.create(null);
        this.mailingAddress.city = "";
        this.mailingAddress.billigAddress1 = "";
        this.mailingAddress.billigAddress2 = "";
        this.mailingAddress.countryCode = "";
        this.mailingAddress.state = "";
        this.mailingAddress.zip = "";
        if (this.firstRegistration && this.firstRegistration.registrantAddress) {
            this.mailingAddress.city = this.firstRegistration.registrantAddress
                ? this.firstRegistration.registrantAddress.city
                : "";
            this.mailingAddress.billigAddress1 = this.firstRegistration
                .registrantAddress
                ? this.firstRegistration.registrantAddress.line1
                : "";
            this.mailingAddress.billigAddress2 = this.firstRegistration
                .registrantAddress
                ? this.firstRegistration.registrantAddress.line2
                : "";
            this.mailingAddress.countryCode = this.firstRegistration.registrantAddress
                ? this.firstRegistration.registrantAddress.countryCode
                : "";
            this.mailingAddress.state = this.firstRegistration.registrantAddress
                ? this.firstRegistration.registrantAddress.stateCode
                : "";
            this.mailingAddress.zip = this.firstRegistration.registrantAddress
                ? this.firstRegistration.registrantAddress.postalCode
                : "";
            this.registrationsInCart.hasAddress = true;
        }
        else {
            this.registrationsInCart.hasAddress = false;
        }
        this.mailingAddress.registrantName =
            this.firstRegistration && this.firstRegistration.registrantName
                ? this.firstRegistration.registrantName
                : "";
        this.mailingAddress.updateAddress = false;
        this.registrationsInCart.firstIteration = false;
        this.mailingAddress.updateAddressCheckBox = false;
        this.registrationsInCart.pickupInPerson = undefined;
        this.registrationsInCart.mailingAddress = this.mailingAddress;
    }
    findRegistrationTypes() {
        this.dmvDataService.getRegistrationTypesResponse(this.sessionID).subscribe(response => {
            if (response) {
                this.registrationTypes = response;
            }
        }, error => {
            error.status = 408;
            this.registrationTypes = error;
        });
    }
    findRegistrations(registrationRequest) {
        this.dmvDataService
            .getRegistrationResponse(registrationRequest.agencyID, registrationRequest.pin, registrationRequest.dateOfBirth, registrationRequest.licensePlate, registrationRequest.expirationDate, registrationRequest.pageSize, registrationRequest.targetPageNumber, this.sessionID, registrationRequest.qrCode, registrationRequest.token)
            .subscribe(response => {
            if (response) {
                this.registrations = response;
                //console.log(registrationResponse);
            }
        }, error => {
            error.status = 408;
            this.registrations = error;
        });
    }
    findRenewal(request, agencyID) {
        this.dmvDataService
            .getRenewalResponse(request, agencyID, this.sessionID)
            .subscribe(response => {
            if (response) {
                this.renewal = response;
                //console.log(registrationResponse);
            }
        }, error => {
            error.status = 408;
            this.renewal = error;
        });
    }
    getServiceFees(renewalToken, agencyID) {
        this.dmvDataService
            .getServiceFeesResponse(renewalToken, agencyID, this.sessionID)
            .subscribe(response => {
            if (response) {
                this.serviceFeeAmount = response;
            }
        }, error => {
            error.status = 408;
            this.serviceFeeAmount = error;
        });
    }
    submitRenewal(renewalToken, agencyID) {
        this.dmvDataService
            .getRenewalSubmitResponse(renewalToken, agencyID, this.sessionID)
            .subscribe(response => {
            if (response && response.status === 200) {
                this.renewalSubmit = response.body;
            }
        }, error => {
            error.status = 408;
            this.renewalSubmit = error;
        });
    }
    findDmvCost(request, agencyID, registrationID) {
        this.dmvDataService
            .getDmvCostResponse(request.newTagCode, request.renewalOptionID, agencyID, registrationID, this.sessionID)
            .subscribe(response => {
            if (response) {
                this.dmvCost = response;
                //console.log(registrationResponse);
            }
        }, error => {
            error.status = 408;
            this.dmvCost = error;
        });
    }
    findAgencyConfigById(agencyID) {
        this.dmvDataService
            .getAgencyConfigResponse(agencyID, this.sessionID)
            .subscribe(response => {
            if (response) {
                this.agencyConfig = response;
            }
        }, error => {
            error.status = 408;
            this.agencyConfig = error;
        });
    }
}
DMVStoreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DMVStoreService_Factory() { return new DMVStoreService(i0.ɵɵinject(i1.DMVDataService)); }, token: DMVStoreService, providedIn: "root" });
